const kumzit1 = "/assets/about/kumzits_mobile_light.webp";
const kumzit2 = "/assets/about/kumzits_mobile_dark.webp";
const kumzit3 = "/assets/about/kumzits_light.webp";
const kumzit4 = "/assets/about/kumzits_dark.webp";
const landlord1 = "/assets/about/landlord_light.webp";
const landlord2 = "/assets/about/landlord_dark.webp";
const supremeedit1 = "/assets/about/supremeedit_light.webp";
const supremeedit2 = "/assets/about/supremeedit_dark.webp";
const juma1 = "/assets/about/juma_dark.webp";
const juma2 = "/assets/about/juma_light.webp";
const kidsplan1 = "/assets/about/kidsplan_dark.webp";
// const kidsplan2 = "/assets/about/kidsplan_light.webp";

import img5 from "@/assets/about/img1.webp";
import img4 from "@/assets/about/img2.webp";

const mobileLight = [
  { id: 1, src: kumzit1 },
  { id: 2, src: landlord1 },
  { id: 3, src: supremeedit1 },
  { id: 4, src: juma2 },
  { id: 5, src: img5 },
];
const mobileDark = [
  { id: 1, src: kumzit2 },
  { id: 2, src: landlord2 },
  { id: 3, src: supremeedit2 },
  { id: 4, src: juma1 },
  { id: 5, src: kidsplan1 },
];
const desktopLight = [
  { id: 1, src: kumzit3 },
  { id: 2, src: landlord1 },
  { id: 3, src: supremeedit1 },
  { id: 4, src: juma2 },
  { id: 5, src: img5 },
];
const desktopDark = [
  { id: 1, src: kumzit4 },
  { id: 2, src: landlord2 },
  { id: 3, src: supremeedit2 },
  { id: 4, src: juma1 },
  { id: 5, src: kidsplan1 },
];

const smallSlots = [
  { x: "-38vw", y: "-12vh", width: 60, height: 25 }, // back-left
  { x: "-25vw", y: "-6vh", width: 110, height: 50 }, // middle-left
  { x: "0vw", y: "0vh", width: 160, height: 100 }, // front
  { x: "25vw", y: "-6vh", width: 110, height: 50 }, // middle-right
  { x: "38vw", y: "-12vh", width: 60, height: 25 }, // back-right
];
const tabletSlots = [
  { x: "-38vw", y: "-16vh", width: 90, height: 37 }, // back-left
  { x: "-25vw", y: "-6vh", width: 165, height: 75 }, // middle-left
  { x: "0vw", y: "0vh", width: 240, height: 150 }, // front
  { x: "25vw", y: "-6vh", width: 165, height: 75 }, // middle-right
  { x: "38vw", y: "-16vh", width: 90, height: 37 }, // back-right
];

const desktopSlots = [
  { x: "-38vw", y: "-24vh", width: 120, height: 50 }, // back-left
  { x: "-25vw", y: "-12vh", width: 220, height: 100 }, // middle-left
  { x: "0vw", y: "0vh", width: 320, height: 200 }, // front
  { x: "25vw", y: "-12vh", width: 220, height: 100 }, // middle-right
  { x: "38vw", y: "-24vh", width: 120, height: 50 }, // back-right
];

const largeSlots = [
  { x: "-800px", y: "-300px", width: 140, height: 58 }, // back-left
  { x: "-600px", y: "-150px", width: 266, height: 166 }, // middle-left
  { x: "0px", y: "0px", width: 373, height: 233 }, // front
  { x: "600px", y: "-150px", width: 266, height: 116 }, // middle-right
  { x: "800px", y: "-300px", width: 140, height: 58 }, // back-right
];
const largestSlots = [
  { x: "-900px", y: "-300px", width: 160, height: 66 }, // back-left
  { x: "-700px", y: "-150px", width: 293, height: 133 }, // middle-left
  { x: "0px", y: "0px", width: 426, height: 266 }, // front
  { x: "700px", y: "-150px", width: 293, height: 133 }, // middle-right
  { x: "900px", y: "-300px", width: 160, height: 66 }, // back-right
];

const aboutUsCards = [
  {
    title: "Integrity",
    description:
      "We act with honesty, uphold ethical standards, and consistently follow through on commitments.",
  },
  {
    title: "Excellence",
    description:
      "We pursue high quality, refine our work continuously, and deliver outstanding results every time.",
  },
  {
    title: "Innovation",
    description:
      "We explore new ideas, adapt to change, and create thoughtful, future-ready solutions.",
  },
  {
    title: "Collaboration",
    description:
      "We believe the best results come from working closely with our clients and each other.",
  },
];

export {
  mobileLight,
  mobileDark,
  desktopLight,
  desktopDark,
  smallSlots,
  tabletSlots,
  desktopSlots,
  largeSlots,
  largestSlots,
  aboutUsCards,
};
